if(window.location.pathname === "/glossary/") {
  document.addEventListener("DOMContentLoaded", function () {	
    document.querySelectorAll('.copy-link').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
          e.preventDefault();

          const link = this.getAttribute('data-link');

          navigator.clipboard.writeText(link).then(() => {

              // show message
              this.classList.add('show-msg');

              // hide after 2 sec
              setTimeout(() => {
                  this.classList.remove('show-msg');
              }, 2000);

          }).catch(err => {
              console.error('Copy failed', err);
          });
      });
  });
    /* smooth scroll */

    document.querySelectorAll(".glossary-left a").forEach(function (link) {
      link.addEventListener("click", function (e) {
        e.preventDefault();

        let target = document.querySelector(this.getAttribute("href"));

        if (target) {
          target.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      });
    });

    /* real time search */

    const searchInput = document.getElementById("glossary-search");
    const noResult = document.getElementById("no-glossary");

    searchInput.addEventListener("input", function () {
      let value = this.value.toLowerCase();
      let found = false;
      let firstMatch = null;

      document.querySelectorAll(".glossary-item").forEach(function (item) {
        let title = item.querySelector("h3").innerText.toLowerCase();

        if (title.includes(value)) {
          item.style.display = "block";
          found = true;

          if (!firstMatch) {
            firstMatch = item;
          }
        } else {
          item.style.display = "none";
        }
      });

      if (!found) {
        noResult.style.display = "block";
      } else {
        noResult.style.display = "none";
      }

      if (firstMatch) {
        firstMatch.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    });
  });
}
